import React, { lazy } from 'react';

const PreEmploymentEntrance = lazy(() =>
  import('@/pages/client/PreEmployment/Entrance')
);

const PreEmploymentAiQuestions = lazy(() =>
  import('@/pages/client/PreEmployment/AiQuestions')
);

const preEmploymentRouters = [
  // needInterceptor: false — user is not logged in when they land here
  { path: '/client/pre-employment/entrance', component: <PreEmploymentEntrance /> },
  { path: '/client/pre-employment/ai-questions', component: <PreEmploymentAiQuestions />, needInterceptor: true },
];

export default preEmploymentRouters;
